export default __webpack_public_path__ + "static/LOGO-SNIPER-NOW-6829a45b51fbc8aca086272bb8b5dd5a.png";